// components/icons/MembersIcon.js
import React from 'react';

const MemberIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M7 21v-2a4 4 0 0 1 3-3.87" />
    <circle cx="12" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M2 21v-2a4 4 0 0 1 3-3.87" />
    <circle cx="16" cy="3" r="2" />
    <circle cx="8" cy="3" r="2" />
  </svg>
);

export default MemberIcon;
